import React, { Suspense } from 'react';

// https://github.com/verlok/lazyload
const lazyLoad = Component => {
    return props => <Suspense fallback={<div></div>}><Component {...props} /></Suspense>;
};

export default lazyLoad;